$(document).ready(function () {
  if (typeof jQuery !== "undefined" && $.fn.slick) {
    console.log("✅ jQuery & Slick loaded");

    // Single slider
    if ($(".slick-slider-wrapper").length) {
      $(".slick-slider-wrapper").slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        arrows: true,
        dots: true,
        adaptiveHeight: true
      });
    }

    // Multi slider
    if ($(".multi-slider").length) {
      $(".multi-slider").slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        infinite: true,
        arrows: true,
        autoplay: true,
        autoplaySpeed: 2000,
        dots: false,
        prevArrow: `<button type="button" class="slick-prev"><img src="https://cdn.shopify.com/s/files/1/0622/4989/4026/files/left-arrow.svg?v=1754993172" alt="Prev"></button>`,
        nextArrow: `<button type="button" class="slick-next"><img src="https://cdn.shopify.com/s/files/1/0622/4989/4026/files/right-arrow.svg?v=1754993171" alt="Next"></button>`,
        responsive: [
          { breakpoint: 1024, settings: { slidesToShow: 3 } },
          { breakpoint: 768, settings: { slidesToShow: 2 } },
          { breakpoint: 480, settings: { slidesToShow: 1 } }
        ]
      });
    }

    // // Product detail sync slider
    // if ($(".slider-single").length && $(".slider-nav").length) {
    //   $(".slider-single").slick({
    //     slidesToShow: 1,
    //     slidesToScroll: 1,
    //     infinite: true,
    //     arrows: true,
    //     fade: true,
    //     autoplay: true,
    //     autoplaySpeed: 2000,
    //     speed: 300,
    //     useTransform: true,
    //     asNavFor: ".slider-nav"
    //   });

    //   $(".slider-nav").slick({
    //     slidesToShow: 3,
    //     slidesToScroll: 1,
    //     infinite: true,
    //     autoplay: true,
    //     autoplaySpeed: 2000,
    //     speed: 300,
    //     asNavFor: ".slider-single",
    //     dots: true,
    //     arrows: true,
    //     prevArrow: `<button type="button" class="slick-prev"><img src="https://cdn.shopify.com/s/files/1/0622/4989/4026/files/left-arrow.svg?v=1754993172" alt="Prev"></button>`,
    //     nextArrow: `<button type="button" class="slick-next"><img src="https://cdn.shopify.com/s/files/1/0622/4989/4026/files/right-arrow.svg?v=1754993171" alt="Next"></button>`,
    //     focusOnSelect: true
    //   });
    // }

  } else {
    console.error("❌ jQuery or Slick not found");
  }

  // Disable Dawn/Tinker sliders
  if (!customElements.get("slider-component")) {
  customElements.define("slider-component", class extends HTMLElement {});
    }

    if (!customElements.get("media-gallery")) {
      customElements.define("media-gallery", class extends HTMLElement {});
    }
});

// Lable Height Jquery
$(document).ready(function () {
  function setDynamicMinHeight(selector) {
    let maxHeight = 0;
    $(selector).css('min-height', 'auto').each(function () {
      const h = $(this).outerHeight();
      if (h > maxHeight) maxHeight = h;
    });
  $(selector).css('min-height', maxHeight + 'px');
}


  const selectors = [
    '',
    
  ];

  selectors.forEach(sel => setDynamicMinHeight(sel));

  $(window).resize(function () {
    selectors.forEach(sel => setDynamicMinHeight(sel));
  });
});


document.addEventListener("DOMContentLoaded", () => {
  const dropdown = document.querySelector(".custom-dropdown");
  if (!dropdown) return;

  const toggle = dropdown.querySelector(".custom-dropdown-toggle");
  const label = toggle.querySelector(".dropdown-label");
  const hiddenSelect = dropdown.querySelector("select");
  const menuItems = dropdown.querySelectorAll(".custom-dropdown-item");

  // Initialize label to selected option
  const selectedOption = hiddenSelect.querySelector("option:checked");
  if (selectedOption) label.textContent = selectedOption.textContent;

  // Toggle dropdown open/close
  toggle.addEventListener("click", (e) => {
    e.stopPropagation();
    dropdown.classList.toggle("open");
  });

  // Click outside closes dropdown
  document.addEventListener("click", () => {
    dropdown.classList.remove("open");
  });

  // Handle item click
  menuItems.forEach(item => {
    item.addEventListener("click", () => {
      const value = item.getAttribute("data-value");
      const text = item.textContent.trim();

      // Update button label
      label.textContent = text;

      // Update hidden select value
      hiddenSelect.value = value;

      // Optionally submit form if exists
      if (hiddenSelect.form) hiddenSelect.form.submit();

      // Close dropdown
      dropdown.classList.remove("open");

      // Update active class
      menuItems.forEach(i => i.classList.remove("active"));
      item.classList.add("active");
    });
  });
});


document.addEventListener("DOMContentLoaded", () => {
  const dropdown = document.querySelector(".custom-dropdown-search");
  if (!dropdown) return;

  const toggle = dropdown.querySelector(".custom-dropdown-toggle-search");
  const label = toggle.querySelector(".dropdown-label-search");
  const hiddenSelect = dropdown.querySelector("select");
  const menuItems = dropdown.querySelectorAll(".custom-dropdown-item-search");

  // Initialize label to selected option
  const selectedOption = hiddenSelect.querySelector("option:checked");
  if (selectedOption) label.textContent = selectedOption.textContent;

  // Toggle dropdown open/close
  toggle.addEventListener("click", (e) => {
    e.stopPropagation();
    dropdown.classList.toggle("open");
  });

  // Click outside closes dropdown
  document.addEventListener("click", () => {
    dropdown.classList.remove("open");
  });

  // Handle option click
  menuItems.forEach(item => {
    item.addEventListener("click", () => {
      const value = item.getAttribute("data-value");
      const text = item.textContent.trim();

      // Update button label
      label.textContent = text;

      // Update hidden select
      hiddenSelect.value = value;

      // Submit form if exists
      if (hiddenSelect.form) hiddenSelect.form.submit();

      // Close dropdown
      dropdown.classList.remove("open");

      // Highlight selected option
      menuItems.forEach(i => i.classList.remove("active"));
      item.classList.add("active");
    });
  });
});




// ----- CONFIG: put possible selectors you want to support here -----
var containerSelectors = [
  '.card__content.bottom-content',
];

var variantPickerSelectors = [
  '.bss-se-variant.optis-variant-picker', // matches elements with BOTH classes
];

var headingSelectors = [
  '.product-info-h3.card__heading',
];
// ------------------------------------------------------------------

// Core function: scans containers and toggles class on matching heading
function applyNoSwatchedClass() {
  var containersSelector = containerSelectors.join(',');
  var variantSelector = variantPickerSelectors.join(',');
  var headingSelector = headingSelectors.join(',');

  $(containersSelector).each(function() {
    var $container = $(this);
    var $heading = $container.find(headingSelector).first();

    if (!$heading.length) return; // no heading, nothing to do

    // If variant picker is NOT present -> ADD class
    if ($container.find(variantSelector).length === 0) {
      $heading.addClass('no-swateched-sec');
    } else {
      // If picker exists -> REMOVE class
      $heading.removeClass('no-swateched-sec');
    }
  });
}

// Run on DOM ready
$(function() {
  applyNoSwatchedClass();
  // expose if you want to call manually later
  window.applyNoSwatchedClass = applyNoSwatchedClass;
});

// OPTIONAL: auto-run when nodes are added (useful if cards are loaded dynamically)
// Debounced to avoid frequent runs
(function enableAutoObserve() {
  var observerConfig = { childList: true, subtree: true };
  var root = document.querySelector('body');
  if (!root) return;

  var debounceTimer = null;
  var observer = new MutationObserver(function(mutations) {
    var added = mutations.some(function(m) {
      return Array.from(m.addedNodes || []).some(function(n) {
        // ignore text nodes
        return n.nodeType === 1;
      });
    });
    if (added) {
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(function() {
        applyNoSwatchedClass();
      }, 80); // 80ms debounce
    }
  });
  observer.observe(root, observerConfig);

  // expose observer if needed
  window._noSwatchObserver = observer;
})();



